// extracted by mini-css-extract-plugin
module.exports = {"componentsCustomerService":"styles_componentsCustomerService__165n7","copyEmail":"styles_copyEmail__1gsGc"};